module.exports = __webpack_public_path__ + "static/img/TippahDwan.7a5567b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/TippahDwan.jpg
// module id = D7dR
// module chunks = 0